const slice = [].slice;
const removeClass = function (elem) {
    elem.classList.remove("focus-within");
};

let running;
let last;

function action() {
    let element = document.activeElement;
    running = false;
    if (last !== element) {
        last = element;
        slice.call(document.getElementsByClassName("focus-within")).forEach(removeClass);
        while (element && element.classList) {
            element.classList.add("focus-within");
            element = element.parentNode;
        }
    }
}

function update() {
    if (!running) {
        requestAnimationFrame(action);
        running = true;
    }
}

document.addEventListener("focus", update, true);
document.addEventListener("blur", update, true);
setTimeout(() => update());
